module.exports = __webpack_public_path__ + "static/img/news_18.ff69387.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_18.jpg
// module id = bI55
// module chunks = 2